import { useEffect, useRef } from 'react';

import { useAccountState } from '@/contexts/account/account-context';
import { setOnboardingStoreAccountId } from '@/features/setup/stores/use-onboarding-flow-store';

export function useOnboardingAccountSync(): void {
  const previousAccountId = useRef<string | null>(null);
  const { accountId } = useAccountState();

  useEffect(() => {
    // Only sync when account ID actually changes
    if (previousAccountId.current === accountId) {
      return;
    }

    previousAccountId.current = accountId ?? null;
    setOnboardingStoreAccountId(accountId ?? null);
  }, [accountId]);
}
